/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finish_Confirm_Decks_WinnerInputs */



/**
* | output |
* | --- |
* | "The winner's decklist becomes public" |
*
* @param {Finish_Confirm_Decks_WinnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finish_confirm_decks_winner = /** @type {((inputs?: Finish_Confirm_Decks_WinnerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finish_Confirm_Decks_WinnerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La decklist du vainqueur devient publique")
	if (locale === "es") return /** @type {LocalizedString} */ ("La decklist del ganador se hace pública")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A decklist do vencedor se torna pública")
	if (locale === "it") return /** @type {LocalizedString} */ ("La decklist del vincitore diventa pubblica")
	return /** @type {LocalizedString} */ ("The winner's decklist becomes public")
});